var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 121,
    viewBox: "0 0 195 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.244 72.8968C193.287 77.2707 191.022 81.2736 187.722 84.8664C172.316 101.542 134.006 109.293 95.7935 105.525C82.3401 104.197 68.9061 101.444 56.4875 97.1483C30.303 88.0882 7.26226 74.7713 0.955336 48.294C-5.70306 20.274 23.2737 -8.91745 62.0134 3.32541C84.5856 10.472 101.124 31.2477 119.401 36.0512C122.818 36.9494 126.274 37.3008 129.867 36.8907C142.5 35.4653 153.064 35.602 161.772 36.9103C183.7 40.2102 193.697 51.0471 194.888 63.6415C195.162 66.629 194.927 69.7531 194.244 72.8968Z",
    fill: "url(#paint0_linear_773_32012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.013 112.711H141.598C141.345 112.711 141.132 112.557 141.132 112.374C141.132 112.191 141.345 112.037 141.598 112.037H155.013C156.063 112.037 156.938 111.418 156.938 110.645C156.938 109.507 158.222 108.593 159.777 108.593H175.623C177.314 108.593 178.695 107.595 178.695 106.373C178.695 105.15 177.314 104.152 175.623 104.152H160.302C159.466 104.152 158.785 103.66 158.785 103.07C158.785 102.831 158.513 102.648 158.183 102.648H113.698C113.445 102.648 113.231 102.494 113.231 102.311C113.231 102.128 113.445 101.974 113.698 101.974H158.183C159.019 101.974 159.699 102.466 159.699 103.056C159.699 103.295 159.971 103.478 160.302 103.478H175.623C177.82 103.478 179.608 104.771 179.608 106.359C179.608 107.947 177.82 109.24 175.623 109.24H159.777C158.727 109.24 157.852 109.858 157.852 110.631C157.852 111.784 156.569 112.711 155.013 112.711Z",
    fill: "url(#paint1_linear_773_32012)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.18 109.668H124.342C124.088 109.668 123.873 109.453 123.873 109.199C123.873 108.945 124.088 108.73 124.342 108.73H130.18C130.434 108.73 130.649 108.945 130.649 109.199C130.649 109.453 130.434 109.668 130.18 109.668Z",
    fill: "#7490FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.18 116.521H124.342C124.088 116.521 123.873 116.307 123.873 116.053C123.873 115.799 124.088 115.584 124.342 115.584H130.18C130.434 115.584 130.649 115.799 130.649 116.053C130.649 116.307 130.434 116.521 130.18 116.521Z",
    fill: "#7490FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.701 113.319V112.636V111.952C141.701 111.581 141.388 111.269 141.017 111.269H139.982V112.636V114.003H141.017C141.408 113.983 141.701 113.69 141.701 113.319Z",
    fill: "url(#paint2_linear_773_32012)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.701 113.319V112.636V111.952C141.701 111.581 141.388 111.269 141.017 111.269H139.982V112.636V114.003H141.017C141.408 113.983 141.701 113.69 141.701 113.319Z",
    fill: "#4E61D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.533 115.33C139.826 114.979 139.982 114.51 139.982 114.061V112.636V111.21C139.982 110.742 139.826 110.293 139.533 109.941C137.737 107.774 135.081 106.505 132.269 106.505H127.466V112.655V118.806H132.269C135.081 118.767 137.756 117.498 139.533 115.33Z",
    fill: "url(#paint3_linear_773_32012)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.533 115.33C139.826 114.979 139.982 114.51 139.982 114.061V112.636V111.21C139.982 110.742 139.826 110.293 139.533 109.941C137.737 107.774 135.081 106.505 132.269 106.505H127.466V112.655V118.806H132.269C135.081 118.767 137.756 117.498 139.533 115.33Z",
    fill: "url(#paint4_linear_773_32012)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.485 119.06V112.636V106.212C127.485 105.938 127.251 105.704 126.977 105.704C126.704 105.704 126.47 105.938 126.47 106.212V112.636V119.06C126.47 119.333 126.704 119.567 126.977 119.567C127.251 119.548 127.485 119.333 127.485 119.06Z",
    fill: "url(#paint5_linear_773_32012)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.485 119.06V112.636V106.212C127.485 105.938 127.251 105.704 126.977 105.704C126.704 105.704 126.47 105.938 126.47 106.212V112.636V119.06C126.47 119.333 126.704 119.567 126.977 119.567C127.251 119.548 127.485 119.333 127.485 119.06Z",
    fill: "#4B5ECE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9297 101.547H118.119V85.1511H87.7269L87.1609 97.9167C87.0828 99.5173 85.9116 100.864 84.3306 101.137L81.9297 101.567V101.547Z",
    fill: "url(#paint6_linear_773_32012)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.898 9.70875V84.1165C166.898 88.157 163.618 91.4168 159.597 91.4168H49.4106C45.3701 91.4168 42.1104 88.1375 42.1104 84.1165V9.70875C42.1104 5.66824 45.3896 2.40851 49.4106 2.40851H159.578C163.618 2.40851 166.878 5.68776 166.878 9.70875H166.898Z",
    fill: "url(#paint7_linear_773_32012)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.898 76.7772V84.136C166.898 88.1765 163.618 91.4363 159.597 91.4363H49.4106C45.3701 91.4363 42.1104 88.157 42.1104 84.136V76.7772H166.898Z",
    fill: "url(#paint8_linear_773_32012)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0215 10.2162C40.0215 5.90247 43.5154 2.40851 47.8292 2.40851H156.981C161.295 2.40851 164.789 5.90247 164.789 10.2162V83.609C164.789 87.9228 161.295 91.4168 156.981 91.4168H47.8487C43.535 91.4168 40.041 87.9228 40.041 83.609V10.2162H40.0215Z",
    fill: "url(#paint9_linear_773_32012)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9014 11.0361C44.9014 8.86941 46.6581 7.11267 48.8248 7.11267H156.006C158.172 7.11267 159.929 8.86941 159.929 11.0361V16.7943H44.9014V11.0361Z",
    fill: "url(#paint10_linear_773_32012)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.264 42.8761L128.949 38.6584L133.167 34.3431C133.772 33.7183 133.752 32.742 133.147 32.1367C132.522 31.5314 131.546 31.5509 130.941 32.1563L126.723 36.4714L122.408 32.2539C121.783 31.6486 120.806 31.668 120.201 32.2733C119.596 32.8786 119.615 33.8745 120.221 34.4798L124.536 38.6975L120.318 43.0127C119.713 43.6375 119.733 44.6139 120.338 45.2192C120.963 45.8245 121.939 45.805 122.544 45.1996L126.762 40.8844L131.077 45.102C131.702 45.7073 132.678 45.6878 133.284 45.0825C133.908 44.4772 133.889 43.4814 133.264 42.8761Z",
    fill: "#7490FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9204 42.8761L84.6051 38.6584L88.8227 34.3431C89.428 33.7183 89.4085 32.742 88.8032 32.1367C88.1784 31.5314 87.2021 31.5509 86.5968 32.1563L82.3791 36.4714L78.0639 32.2539C77.439 31.6486 76.4627 31.668 75.8574 32.2733C75.2521 32.8786 75.2716 33.8745 75.8769 34.4798L80.1922 38.6975L75.9746 43.0127C75.3693 43.6375 75.3888 44.6139 75.9941 45.2192C76.6189 45.8245 77.5952 45.805 78.2006 45.1996L82.4182 40.8844L86.7334 45.102C87.3583 45.7073 88.3346 45.6878 88.9399 45.0825C89.5452 44.4772 89.5257 43.4814 88.9204 42.8761Z",
    fill: "#7490FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.6 56.5442H90.5211C89.701 56.5442 89.0371 55.8803 89.0371 55.0602C89.0371 54.2401 89.701 53.5762 90.5211 53.5762H118.6C119.42 53.5762 120.084 54.2401 120.084 55.0602C120.084 55.8803 119.42 56.5442 118.6 56.5442Z",
    fill: "#7490FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0215 76.7578H164.809V84.0189C164.809 88.0985 161.49 91.4168 157.411 91.4168H47.4193C43.3398 91.4168 40.0215 88.0985 40.0215 84.0189V76.7578Z",
    fill: "url(#paint11_linear_773_32012)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102.425 86.2832C103.859 86.2832 105.021 85.1209 105.021 83.6871C105.021 82.2533 103.859 81.091 102.425 81.091C100.991 81.091 99.8291 82.2533 99.8291 83.6871C99.8291 85.1209 100.991 86.2832 102.425 86.2832Z",
    fill: "#181D40"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6599 13.964C51.7703 13.964 52.6704 13.0638 52.6704 11.9535C52.6704 10.8431 51.7703 9.94299 50.6599 9.94299C49.5495 9.94299 48.6494 10.8431 48.6494 11.9535C48.6494 13.0638 49.5495 13.964 50.6599 13.964Z",
    fill: "#7490FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1794 13.964C58.2898 13.964 59.1899 13.0638 59.1899 11.9535C59.1899 10.8431 58.2898 9.94299 57.1794 9.94299C56.0691 9.94299 55.1689 10.8431 55.1689 11.9535C55.1689 13.0638 56.0691 13.964 57.1794 13.964Z",
    fill: "#7490FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6785 13.964C64.7888 13.964 65.689 13.0638 65.689 11.9535C65.689 10.8431 64.7888 9.94299 63.6785 9.94299C62.5681 9.94299 61.668 10.8431 61.668 11.9535C61.668 13.0638 62.5681 13.964 63.6785 13.964Z",
    fill: "#7490FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.221 91.4363V99.5173C117.221 100.649 116.303 101.567 115.171 101.567H73.1069C72.3652 101.567 71.721 102.113 71.643 102.836C71.5649 103.558 72.2285 104.378 73.0484 104.378H115.796C118.138 104.378 120.051 102.484 120.051 100.122V91.4363H117.24H117.221Z",
    fill: "url(#paint12_linear_773_32012)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9056 57.5494H34.1121L61.6243 112.457H3.69043C1.05441 112.457 -0.605301 109.606 0.722472 107.321L28.2347 59.6778C28.9962 58.35 30.4021 57.5494 31.9056 57.5494Z",
    fill: "url(#paint13_linear_773_32012)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8462 59.3654L64.3389 107.009C65.7448 109.43 63.9874 112.476 61.1952 112.476H6.19022C3.37846 112.476 1.64064 109.45 3.04652 107.009L30.5392 59.3654C31.9451 56.9441 35.4403 56.9441 36.8462 59.3654Z",
    fill: "url(#paint14_linear_773_32012)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.875 99.55C29.875 101.346 31.1247 102.869 32.8039 103.26C33.0773 103.318 33.3702 103.358 33.6826 103.358C35.7914 103.358 37.4902 101.659 37.4902 99.55C37.4902 97.4411 35.7914 95.7424 33.6826 95.7424C33.3897 95.7424 33.0773 95.7814 32.8039 95.84C31.1442 96.2305 29.875 97.7536 29.875 99.55Z",
    fill: "url(#paint15_linear_773_32012)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2266 77.2121C30.2266 77.3292 30.2266 77.4269 30.2461 77.5441L31.7105 92.7353H35.6743L37.1388 77.5441C37.3341 75.5133 35.7329 73.7559 33.7022 73.7559C33.3898 73.7559 33.0969 73.795 32.8235 73.8731C31.32 74.2636 30.2266 75.6305 30.2266 77.2121Z",
    fill: "url(#paint16_linear_773_32012)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.875 99.5499C29.875 100.682 30.3827 101.717 31.1637 102.42C32.101 103.24 33.5069 103.24 34.4441 102.42C35.2447 101.717 35.7328 100.702 35.7328 99.5499C35.7328 98.3588 35.1861 97.2849 34.3074 96.582C33.4288 95.879 32.1596 95.879 31.2809 96.582C30.4413 97.2849 29.875 98.3588 29.875 99.5499Z",
    fill: "#262730"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2266 77.2121C30.2266 77.3293 30.2266 77.4269 30.2461 77.5441L31.7105 92.7353H33.917L35.3814 77.5441C35.401 77.2902 35.401 77.0363 35.3619 76.7825C34.9909 73.795 30.4999 73.8926 30.2266 76.8997C30.2266 77.0168 30.2266 77.1145 30.2266 77.2121Z",
    fill: "#262730"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_32012",
    x1: -0.0107947,
    y1: 53.4365,
    x2: 194.994,
    y2: 53.4365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5B78",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37D92",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_773_32012",
    x1: 133.891,
    y1: 107.349,
    x2: 200.256,
    y2: 107.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#39429D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_773_32012",
    x1: 139.999,
    y1: 112.624,
    x2: 141.707,
    y2: 112.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#0A2EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_773_32012",
    x1: 127.476,
    y1: 112.624,
    x2: 139.998,
    y2: 112.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#0A2EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_773_32012",
    x1: 131.361,
    y1: 112.662,
    x2: 143.875,
    y2: 112.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#39429D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_773_32012",
    x1: 126.472,
    y1: 112.624,
    x2: 127.476,
    y2: 112.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#0A2EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_773_32012",
    x1: 86.9071,
    y1: 93.2516,
    x2: 122.549,
    y2: 93.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CAD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A2B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_773_32012",
    x1: 162.838,
    y1: 46.9126,
    x2: 180.034,
    y2: 46.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3143BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8FA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_773_32012",
    x1: 141.034,
    y1: 84.097,
    x2: 158.231,
    y2: 84.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F0F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CCD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_773_32012",
    x1: 37.2107,
    y1: 15.5841,
    x2: 161.334,
    y2: 75.2352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D47B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#39429E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#353A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#323779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2A2F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1D224C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_773_32012",
    x1: 92.9775,
    y1: -20.4682,
    x2: 102.113,
    y2: 12.5195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#33387A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D326E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#232859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_773_32012",
    x1: 73.1263,
    y1: 83.9018,
    x2: 193.561,
    y2: 84.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F9FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CFD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ACBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_773_32012",
    x1: 67.4658,
    y1: 97.8972,
    x2: 119.114,
    y2: 97.8972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C4D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9DB0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_773_32012",
    x1: 33.0615,
    y1: 85.0033,
    x2: -28.3021,
    y2: 85.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F4673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5166,
    stopColor: "#F15C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7544,
    stopColor: "#EC4A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#E5303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_773_32012",
    x1: 64.8416,
    y1: 85.0033,
    x2: 2.54597,
    y2: 85.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F4673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5166,
    stopColor: "#F15C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7544,
    stopColor: "#EC4A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#E5303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_773_32012",
    x1: 35.2125,
    y1: 99.5482,
    x2: 27.5916,
    y2: 99.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F4673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5166,
    stopColor: "#F15C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7544,
    stopColor: "#EC4A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#E5303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_773_32012",
    x1: 31.5385,
    y1: 83.2492,
    x2: 24.6161,
    y2: 83.2492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F4673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5166,
    stopColor: "#F15C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7544,
    stopColor: "#EC4A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#E5303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.acda2247317e7f460365cd6365791618.svg";
export { ForwardRef as ReactComponent };